// @ts-check

import { sourceType } from './sourceType';

/**
 * @module files/CloudFile
 */

/** Class representing a cloud file */
export default class CloudFile {
    /**
     * Create a CloudFile
     * @param {Object} params
     * @param {string} params.downloadUrl - Url to download the file
     * @param {string} params.editUrl - Url to edit the file
     * @param {string} params.id - cloud file id
     * @param {boolean} params.isRegisteredWithCasper
     * @param {boolean} params.isSupportedByCasper
     * @param {boolean} params.isTemplate
     * @param {string} params.mimeType
     * @param {string} params.name
     * @param {Object} params.oAuthContext
     * @param {number} params.sourceType
     * @param {string} params.viewUrl
     */
    constructor({
        downloadUrl,
        editUrl,
        id,
        isRegisteredWithCasper,
        isSupportedByCasper,
        isTemplate,
        mimeType,
        name,
        oAuthContext,
        sourceType,
        viewUrl
    }) {
        this.downloadUrl = downloadUrl;
        this.editUrl = editUrl;
        this.id = id;
        this.isRegisteredWithCasper = isRegisteredWithCasper;
        this.isSupportedByCasper = isSupportedByCasper;
        this.isTemplate = isTemplate;
        this.mimeType = mimeType;
        this.name = name;
        this.oAuthContext = oAuthContext;
        this.sourceType = sourceType;
        this.viewUrl = viewUrl;
    }

    /**
     * Create a CloudFile from a google file
     * @param {Object} file
     * @param {string} file.url
     * @param {string} file.id
     * @param {string} file.name
     * @param {string} file.mimeType
     * @param {Object} oAuthContext
     */
    static fromGoogle(file, oAuthContext) {
        const googleDriveDownloadUrl = 'https://drive.google.com/uc?export=download&id={fileId}';
        const downloadUrl = googleDriveDownloadUrl.replace('{fileId}', file.id);

        return new CloudFile({
            downloadUrl: downloadUrl,
            editUrl: file.url,
            id: file.id,
            isRegisteredWithCasper: false,
            isSupportedByCasper: true,
            isTemplate: false,
            mimeType: file.mimeType,
            name: file.name,
            oAuthContext: oAuthContext,
            sourceType: sourceType.google,
            viewUrl: file.url,
        });
    }

    /**
     * Create a CloudFile from a google file
     * @param {Object} file
     * @param {string} file.url
     * @param {number} file.sourceType
     * @param {string} file.id
     * @param {string} file.name
     * @param {string} file.mimeType
     * @param {Object} oAuthContext
     */
    static fromOneDrive(file, oAuthContext) {
        return new CloudFile({
            downloadUrl: null,
            editUrl: file.url,
            id: file.id,
            isRegisteredWithCasper: false,
            isSupportedByCasper: true,
            isTemplate: false,
            mimeType: file.mimeType,
            name: file.name,
            oAuthContext: oAuthContext,
            sourceType: file.sourceType,
            viewUrl: file.url,
        });
    }
};
